module.exports = {
  "zones": {
    "Canada/Pacific": ["z", {
      "wallclock": 536457600000,
      "format": "P%sT",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": 536486400000,
      "save": 0,
      "rules": "Canada"
    }, {
      "wallclock": -2713910400000,
      "format": "P%sT",
      "abbrev": "PST",
      "offset": -28800000,
      "posix": -2713880852000,
      "save": 0,
      "rules": "Vanc"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -29548000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Canada": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1975,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 3,
      "day": [7, 14],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 9,
      "day": [7, 27],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }],
    "Vanc": [{
      "from": 1962,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1961,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1946,
      "month": 9,
      "day": [7, 13],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 3,
      "day": [7, 14],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 9,
      "day": [7, 27],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};